module.exports = __webpack_public_path__ + "static/media/icon_open-in-new-sm.21c3d4d5.svg";